import { Component, isDevMode, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateService } from '@ngx-translate/core';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';



@Component({
    selector: 'div.dtf-maintenance',
    imports: [SharedTranslateModule],
    templateUrl: './maintenance.component.html',
    providers: []
})

export class MaintenanceComponent implements OnInit {
    router: Router;
    isCanadaPortal = false;
    language = '';
    brandId: string;
    usUrl: string;
    caUrl: string;
    private _window: WindowRef;
    targetRedirect = '';

    constructor(router: Router,  window: WindowRef,public translateUtil: TranslateUtil, public translate: TranslateService ) {
        this.router = router;
        this._window = window;
        this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    }

    ngOnInit() {
      this.translateUtil.setCountryAndLangFromUIProp();
      this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      });
      this.language = (this._window.nativeWindow as any).mbfs.language;

        // Set page error value for analytics
      ((window as any).mbfs).pageInfo = {pageError: '404'};
      this.buildRedirectURL();
    }


    buildRedirectURL() {
        if (this.language === 'en-CA') {
          this.targetRedirect = this.usUrl + '/ca/en/home';
        }
        else if (this.language === 'fr-CA') {
          this.targetRedirect = this.usUrl + '/ca/fr/home';
        }
        else {
          this.targetRedirect = this.usUrl + '/home';
        }
      }
}
